import React from 'react';
import { Row, Col, Skeleton } from 'antd';
import './styles.scss';

export const BookingConfirmationSkeleton: React.FC = () => {
    return (
        <div className="booking-confirmation-skeleton">
            {/* Header / ActivityBanner Section Skeleton */}
            <div className="skeleton-hero">
                <div className="hero-content">
                    <Skeleton.Avatar active size={64} className="hero-icon" />
                    <Skeleton.Input active size="large" style={{ width: 300, height: 40 }} />
                    <Skeleton.Input active size="small" style={{ width: 400, marginTop: 10 }} />
                    <div className="hero-badges">
                        <Skeleton.Button active shape="round" style={{ width: 120 }} />
                        <Skeleton.Button active shape="round" style={{ width: 120 }} />
                        <Skeleton.Button active shape="round" style={{ width: 120 }} />
                    </div>
                </div>
            </div>

            <div className="confirmation-body">
                <Row gutter={[32, 32]}>
                    <Col xs={24} lg={16}>
                        {/* What's Next Skeleton */}
                        <section className="info-card-skeleton next-steps">
                            <div className="card-header">
                                <Skeleton.Input active size="default" style={{ width: 150 }} />
                            </div>
                            <div className="steps-grid-skeleton">
                                {[1, 2, 3].map((i) => (
                                    <div key={i} className="step-skeleton">
                                        <Skeleton.Avatar active size="small" shape="circle" />
                                        <div style={{ width: '100%' }}>
                                            <Skeleton.Input active size="small" style={{ width: '60%', marginBottom: 8 }} />
                                            <Skeleton.Input active size="small" block style={{ height: 16 }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* Cancellation Policy Skeleton */}
                        <section className="info-card-skeleton">
                            <div className="card-header">
                                <Skeleton.Input active size="default" style={{ width: 180 }} />
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Skeleton.Button active size="small" shape="round" style={{ width: 80 }} />
                                    <Skeleton.Button active size="small" shape="round" style={{ width: 80 }} />
                                </div>
                            </div>
                            <div className="policy-list-skeleton">
                                <Skeleton active paragraph={{ rows: 2, width: ['90%', '80%'] }} title={false} />
                            </div>
                        </section>

                        {/* Important Info Skeleton */}
                        <section className="info-card-skeleton">
                            <div className="card-header">
                                <Skeleton.Input active size="default" style={{ width: 200 }} />
                            </div>
                            <div className="policy-list-skeleton">
                                <Skeleton active paragraph={{ rows: 4 }} title={false} />
                            </div>
                        </section>
                    </Col>

                    <Col xs={24} lg={8}>
                        {/* Sidebar "Ticket" Summary Skeleton */}
                        <aside className="summary-ticket-skeleton">
                            <div className="ticket-visual-skeleton">
                                <Skeleton.Image style={{ width: '100%', height: '100%' }} />
                            </div>

                            <div className="ticket-details-skeleton">
                                <Skeleton.Input active size="default" style={{ width: '80%', marginBottom: 16 }} />

                                <div className="modality-box-skeleton">
                                    <Skeleton.Input active size="small" style={{ width: '60%', marginBottom: 12 }} />
                                    <Skeleton active paragraph={{ rows: 1, width: ['100%'] }} title={false} />
                                </div>

                                <div className="price-breakdown-skeleton">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Skeleton.Input active size="small" style={{ width: 80 }} />
                                        <Skeleton.Input active size="small" style={{ width: 60 }} />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Skeleton.Input active size="small" style={{ width: 80 }} />
                                        <Skeleton.Input active size="small" style={{ width: 60 }} />
                                    </div>
                                 
                                </div>
                            </div>
                        </aside>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
